"use strict";
/**
 * Fitxer: AppApi.ts
 * Autor: Jordi Riu Amblàs
 * Data: 15/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ajt_ajax_1 = require("ajt-ajax");

var AppApi =
/** @class */
function (_super) {
  __extends(AppApi, _super);

  function AppApi(appState, config) {
    var _this = this;

    config = __assign({
      messageFromError: function messageFromError(error) {
        return {
          message: error.message
        };
      }
    }, config);
    _this = _super.call(this, Object.assign({
      onError: function onError(error) {
        if (error.response && error.response.status && error.response.status === 401) {
          appState.sessState.reset();
          appState.notiState.showMessage('Sessió caducada o sense permís!', 'warning');
          appState.pantState.goPantalla('/login');
        } else {
          var _a = config.messageFromError(error),
              message = _a.message,
              variant = _a.variant;

          if (message !== undefined) {
            appState.notiState.showMessage(message, variant || 'error');
          }
        }
      },
      onLoadingChange: function onLoadingChange(loading) {
        appState.loadState.setIsLoading(loading);
      }
    }, config)) || this;
    return _this;
  }

  return AppApi;
}(ajt_ajax_1.default);

exports.default = AppApi;